import { render, staticRenderFns } from "./Atividades.vue?vue&type=template&id=3cda8bbc"
import script from "./Atividades.vue?vue&type=script&lang=js"
export * from "./Atividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports